import { GET_SHOW_PEFORMANCE_RATING , UPDATE_SHOW_PERFORMANCE_RATING } from '../../../actions/constants'; 

const initialState = {
  show_performance_rating : {
    graphData : null,
    response : null
  }
}

const showPerformanceRating = (state = initialState , action) => {
  switch (action.type) {
    case GET_SHOW_PEFORMANCE_RATING : {
      const newState = Object.assign({},state, {
        show_performance_rating : { ...state.show_performance_rating , ...action.payload }
      })
      return newState;
    }

    case UPDATE_SHOW_PERFORMANCE_RATING : {
      const newState = Object.assign({},state,{
        show_performance_rating : { ...state.show_performance_rating , ...action.payload }
      })
      return newState;
    }

    default:
      return state;
  }
};
  
export default showPerformanceRating;
  